const Config = {
    appName: process.env.REACT_APP_APP_NAME || 'DPP Web UI',
    
    defaultLanguage: process.env.REACT_APP_DEFAULT_LANGUAGE || 'de',

    appearance: {
        mainColor: '#003E81',
        secondaryColor: '#F1F6FB',
        brandHeight: '64px',
        navbarHeight: '120px',
        secondaryNavbarHeight: '68px',
        footerHeight: '120px',
    },
    
    isDemo: process.env.REACT_APP_DEMO_MODE,

    demo: {
        authentication : {
            grant_type: process.env.REACT_APP_DEMO_AUTHENTICATION_GRANT_TYPE,
            username: process.env.REACT_APP_DEMO_AUTHENTICATION_USERNAME,
            password: process.env.REACT_APP_DEMO_AUTHENTICATION_PASSWORD
        },
        banner: {
            companyName: process.env.REACT_APP_DEMO_BANNER_COMPANY_NAME || null,
            companyUrl:  process.env.REACT_APP_DEMO_BANNER_COMPANY_URL  || null,
            productUrl:  process.env.REACT_APP_DEMO_BANNER_PRODUCT_URL  || null,
            backgroundColor: process.env.REACT_APP_DEMO_BANNER_BG_COLOR || '#0a1628',
            sticky: process.env.REACT_APP_DEMO_BANNER_STICKY === 'true',
        },
    },

    keycloakService: {
        url: process.env.REACT_APP_KEYCLOAK_URL || '',
        realm: process.env.REACT_APP_KEYCLOAK_REALM || '',
        clientId: process.env.REACT_APP_KEYCLOAK_CLIENTID || '',
        tokenRefreshInterval: process.env.REACT_APP_KEYCLOAK_TOKEN_REFRESH_INTERVAL || 30,
    },

    dppManagerService: {
        baseUrl: process.env.REACT_APP_DPP_MANAGER_URL || '',
    },

    filebrowserService: {
        baseUrl: process.env.REACT_APP_FILEBROWSER_URL || '',
        username: process.env.REACT_APP_FILEBROWSER_USER || '',
        password: process.env.REACT_APP_FILEBROWSER_PASSWORD || '',
        serviceRequestNotificationsRoot: process.env.REACT_APP_FILEBROWSER_SERVICE_REQUEST_NOTIFICATIONS_ROOT || '/',
    },
    
    dpp: {
        submodels: {
            orderByIdShort: [
                'PublicInformation',
                'Nameplate',
                'TechnicalData',
                'HandoverDocumentation',
                'CO2Footprint',
                'CircularEconomy',
                'CarbonFootprint',
                'BillOfMaterials',
                'ServiceRequestNotification'
            ],
        },
    },

    company: {
        name: process.env.REACT_APP_COMPANY_NAME || 'Lorenz GmbH & Co.KG',
        legalForm: 'GmbH & Co.KG',
        address: {
            street: process.env.REACT_APP_COMPANY_STREET || 'Burgweg',
            houseNumber: process.env.REACT_APP_COMPANY_HOUSENUMBER || '3',
            zipCode: process.env.REACT_APP_COMPANY_ZIPCODE || '89601',
            city: process.env.REACT_APP_COMPANY_CITY || 'Schelklingen',
            country: process.env.REACT_APP_COMPANY_COUNTRY || 'DE', // ISO 3166-1 alpha-2
            latitude: process.env.REACT_APP_COMPANY_LATITUDE || '48.395271',
            longitude: process.env.REACT_APP_COMPANY_LONGITUDE || '9.64499',
        },
        contact: {
            phone: process.env.REACT_APP_COMPANY_PHONE || '+49 (0)7384 / 95 981-0',
            email: process.env.REACT_APP_COMPANY_EMAIL || 'info@lorenz-meters.de',
            website: process.env.REACT_APP_COMPANY_WEBSITE || 'https://www.lorenz-meters.de',
        },
    },
};

export default Config;